import React from "react";

interface WarningIconProps {
  className?: string;
  width?: number;
  height?: number;
}

const WarningIcon: React.FC<WarningIconProps> = ({ className, width = 24, height = 24 }) => {
  return (
    <svg 
      width={width} 
      height={height} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path 
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" 
        fill="#FFEED6"
      />
      <path 
        d="M11.9998 7.66272L17.0198 16.3361H6.97976L11.9998 7.66272ZM5.82642 15.6694C5.31309 16.5561 5.95309 17.6694 6.97976 17.6694H17.0198C18.0464 17.6694 18.6864 16.5561 18.1731 15.6694L13.1531 6.99605C12.6398 6.10939 11.3598 6.10939 10.8464 6.99605L5.82642 15.6694ZM11.3331 11.0027V12.3361C11.3331 12.7027 11.6331 13.0027 11.9998 13.0027C12.3664 13.0027 12.6664 12.7027 12.6664 12.3361V11.0027C12.6664 10.6361 12.3664 10.3361 11.9998 10.3361C11.6331 10.3361 11.3331 10.6361 11.3331 11.0027ZM11.3331 14.3361H12.6664V15.6694H11.3331V14.3361Z" 
        fill="#5B440B"
      />
    </svg>
  );
};

export default WarningIcon;
